import { Phone, Mail, MapPin, MessageCircle, Globe } from "lucide-react";
import { BRAND } from "@/data/content";

const FOOTER_COLS = [
  { title: "Solutions", links: ["Residential", "Commercial", "Industrial", "Agriculture", "Water Pumps", "Street Lighting"] },
  { title: "Company", links: ["About Us", "Projects", "Why Choose Us", "Testimonials", "Careers"] },
];

const Footer = () => (
  <footer className="bg-brand-navy text-slate-300" data-testid="footer">
    <div className="max-shell mx-auto px-4 md:px-8 lg:px-12 py-16">
      <div className="grid gap-10 lg:grid-cols-[1.5fr_1fr_1fr]">
        <div>
          <div className="flex items-center shrink-0">
            <img src={`${process.env.PUBLIC_URL}/logo.jpeg`} alt="Logo" className="h-28 w-auto max-w-[320px] object-contain bg-white rounded-xl p-2" />
          </div>
          <p className="mt-5 text-sm leading-relaxed text-slate-400 max-w-xs">
            End-to-end solar energy solutions for homes, businesses, industries and farms.
          </p>
        </div>

        {FOOTER_COLS.map((col) => (
          <div key={col.title}>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider">{col.title}</h4>
            <ul className="mt-4 space-y-3">
              {col.links.map((l) => (
                <li key={l}>
                  <a href="#solutions" className="text-sm text-slate-400 hover:text-brand-green transition-colors">{l}</a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-12 border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-center gap-8 text-slate-300">
        <a href="tel:+916304408653" className="flex items-center gap-3 hover:text-brand-green transition-colors">
          <Phone className="w-5 h-5 text-brand-green" />
          <span className="text-lg md:text-xl font-medium tracking-wide">+91 6304408653</span>
        </a>
        <a href="mailto:globalecos7777@gmail.com" className="flex items-center gap-3 hover:text-brand-yellow transition-colors">
          <Mail className="w-5 h-5 text-brand-yellow" />
          <span className="text-lg md:text-xl font-medium tracking-wide">globalecos7777@gmail.com</span>
        </a>
      </div>

      <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-slate-500">
        <p>
          © {new Date().getFullYear()} {BRAND.full}. All rights reserved. Powered by <a href="https://getaivry.com/" target="_blank" rel="noreferrer" className="text-slate-300 hover:text-brand-green transition-colors">aivry</a>
        </p>
        <div className="flex gap-6">
          <a href="#" className="hover:text-brand-green transition-colors">Privacy Policy</a>
          <a href="#" className="hover:text-brand-green transition-colors">Terms of Service</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
